module.exports = __webpack_public_path__ + "e03e5e30658e278fa4d551ba028ac68e.svg";